module.exports = "/images/cw.svg?e5c487f12b3bf9ea3b157ff1339ab1b3";